import { useEffect, useState } from 'react';

import { BrowserBreakpoints } from './Breakpoints';

export const initialValue: Readonly<BrowserBreakpoints> = {
  is: {
    mobile: true,
    tablet: false,
    desktop: false,
  },
  greaterThan: {
    mobile: false,
    tablet: false,
    desktop: false,
  },
  lessThan: {
    mobile: false,
    tablet: true,
    desktop: true,
  },
};

export function useBrowserInternal() {
  const [browser, setBrowser] = useState<BrowserBreakpoints>(initialValue);

  const [isMobile, setIsMobile] = useState(initialValue.is.mobile);
  const [isTablet, setIsTablet] = useState(initialValue.is.tablet);
  const [isDesktop, setIsDesktop] = useState(initialValue.is.desktop);
  const [isDesktopLarge, setIsDesktopLarge] = useState(false);

  useEffect(() => setBrowser({
    is: {
      mobile: isMobile,
      tablet: isTablet,
      desktop: isDesktop || isDesktopLarge,
    },
    greaterThan: {
      mobile: isTablet || isDesktop || isDesktopLarge,
      tablet: isDesktop || isDesktopLarge,
      desktop: isDesktopLarge,
    },
    lessThan: {
      mobile: false,
      tablet: isMobile,
      desktop: isTablet || isMobile,
    },
  }), [
    isMobile,
    isTablet,
    isDesktop,
    isDesktopLarge,
  ]);

  return { browser, setIsMobile, setIsTablet, setIsDesktop, setIsDesktopLarge };
}
